const hasMeaningfulContent = (val) => {
  if (val == null || val === '') return false;
  const stripped = String(val)
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
  return stripped.length > 0;
};

export default hasMeaningfulContent;
